import { ChannelType } from 'components/ChannelPicker/types';
import {
    Query, limit, query, orderBy, where,
} from 'firebase/firestore';

const buildFilters = ({
    ref,
    channel,
    conversationFilter,
}: {
    ref: Query;
    channel: ChannelType;
    conversationFilter: string;
}) => {
    const filters = [];

    if (conversationFilter === 'unread') {
        filters.push(where('seenStatus', '==', 'unseen'));
    } else if (conversationFilter === 'ai-disabled') {
        filters.push(where('aiResponseStatus', '==', 'disabled'));
    }

    if (channel !== 'all') {
        if (channel === 'widget_chatbot') {
            return query(
                ref,
                where('from.channel', 'not-in', ['facebook', 'instagram', 'whatsapp', 'tiktok', 'telegram']),
                ...filters,
                orderBy('from.channel', 'desc'),
                orderBy('lastMessage.createdAt', 'desc'),
                limit(3000),
            );
        }
        return query(
            ref,
            where('from.channel', '==', channel),
            ...filters,
            orderBy('lastMessage.createdAt', 'desc'),
            limit(3000),
        );
    }
    return query(
        ref,
        ...filters,
        orderBy('lastMessage.createdAt', 'desc'),
        limit(3000),
    );
};

export default buildFilters;
